import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { dropdownAnimation } from '@animations/dropdown.animations';
import { DropDownOption, DropDownType, GroupedDropDownOption } from '@interfaces/common/form.interface';

@Component({
  selector: 'app-dropdown-options',
  templateUrl: './dropdown-options.component.html',
  styleUrls: ['./dropdown-options.component.scss'],
  animations: [dropdownAnimation()]
})
export class DropdownOptionsComponent {
  @ViewChild('wrapper')
  wrapper!: ElementRef;

  @Input() open = false;
  @Input() options: DropDownOption[] = [];
  @Input() groupedOptions: GroupedDropDownOption[] = [];

  @Input() type: DropDownType = 'list';
  @Input() minimum = 1;

  @Output() saved = new EventEmitter<DropDownOption[]>();
  @Output() closed = new EventEmitter<void>();
  @Output() cleared = new EventEmitter<void>();

  @Output() changed = new EventEmitter<DropDownOption[]>();
  @Output() selected = new EventEmitter<DropDownOption>();

  prevSearch = '';
  prevSearchIdx = 0;

  get empty(): boolean {
    if (this.type !== 'groupList') {
      return this.options.filter(e => e.selected)?.length <= 0;
    } else {
      const opt: DropDownOption[] = [];
      this.groupedOptions.forEach(group => {
        group.options.forEach(o => opt.push(o));
      });
      return opt.filter(e => e.selected)?.length <= 0;
    }

  }
  get valid(): boolean {
    return this.options.filter(e => e.selected)?.length >= this.minimum;
  }

  @HostListener('document:keyup', ['$event'])
  handleDeleteKeyboardEvent(event: KeyboardEvent) {
    this.findEntry(event);
  }

  constructor() {}

  // @HostListener('document:click', ['$event.target'])
  // public onClick(target: any): void {
  //   const wrapperRef = this.wrapper?.nativeElement;
  //   if (wrapperRef && !wrapperRef.contains(target)) {
  //     this.open = false;
  //     this.closed.emit();
  //   }
  // }

  select(option: DropDownOption): void {
    option.selected = !option.selected;
    if (option.selected) {
      this.selected.emit(option);
      this.open = false;
      this.closed.emit();
    }
    this.changed.emit(this.options.filter(e => e.selected));
    this.clearHighlights();
  }

  selectOne(option: DropDownOption): void {
    // this.clear();
    if (!option.disabled) {
      option.selected = true;
      this.selected.emit(option);
      this.closed.emit();
      this.clearHighlights();
    }
  }

  save(): void {
    this.saved.emit(this.options.filter(e => e.selected));
    this.closed.emit();
  }

  clearHighlights() {
    for (const option of this.options) {
      option.highlighted = false;
    }
  }

  findEntry(event: KeyboardEvent) {
    if (this.open) {
      if (/^[a-zA-Z0-9]+$/.test(event.key)) {
        if (this.prevSearch === event.key) {
          this.prevSearchIdx++;
        } else {
          this.prevSearchIdx = 0;
        }
        this.prevSearch = event.key;
        this.clearHighlights();
        let idx = 0;
        let found = false;
        for (const option of this.options) {
          if (option.name.substring(0, 1).toLowerCase() === event.key.toLowerCase()) {
            const optGroup = this.options.filter(el => el.name.substring(0, 1).toLowerCase() === event.key.toLowerCase());
            if (optGroup.length) {
              if (this.prevSearchIdx >= optGroup.length) {
                this.prevSearchIdx = 0;
              }
              if (optGroup[this.prevSearchIdx] === option) {
                option.highlighted = true;
                found = true;
                break;
              }
            } else {
              option.highlighted = true;
              found = true;
              break;
            }
          }
          idx++;
        }
        if (found) {
          const listEl = this.wrapper.nativeElement.querySelector('.list') as HTMLElement;
          const listItems = this.wrapper.nativeElement.querySelectorAll('.list-item');
          if (listItems[idx] && listEl) {
            const item = listItems[idx] as HTMLElement;
            const itemRect = item.getBoundingClientRect();
            const listRect = listEl.getBoundingClientRect();
            if (itemRect.top < listRect.top) {
              listEl.scrollTop -= listRect.top - itemRect.top;
            } else if (itemRect.bottom > listRect.bottom) {
              listEl.scrollTop += itemRect.bottom - listRect.bottom;
            }
          }
        }
      }
    }
  }
}
